const { TextField } = require("@mui/material");
const { Fragment } = require("react");

const TextInput = ({ label, value, onChange, ...props }) => (
  <Fragment>
    <TextField
      label={label}
      placeholder={label}
      variant="outlined"
      fullWidth
      value={value}
      onChange={(e) => onChange(e.target.value)}
      margin="normal"
      {...props}
    />
  </Fragment>
);

export default TextInput;
